<template>
  <div class="px-16 pb-10 pt-4">
    <div style="height: 70vh;">
      <iframe class="w-full h-full" id="blob"></iframe>
    </div>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'

const setPdfUrl = (pdf, filename) => {
  const blobFile = new File([pdf], filename, { type: 'application/pdf' })
  document.querySelector('#blob').src = URL.createObjectURL(blobFile);
}

const b64toBlob = (dataURI) => {
  const byteString = atob(dataURI.split(',')[1])
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return new Blob([ab], { type: 'application/pdf' });
}

export default {
  props: {
    licenseId: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      licenses: Licenses,
      document: ''
    }
  },
  async created() {
    this.licenses = new Licenses()
    try {
      const documentResponse = await this.licenses.getUploadedDocument(this.licenseId)
      const contentDisposition = documentResponse[0].headers['content-disposition'];
      const filename = contentDisposition.split(';')[1].split('=')[1].replace('"', '').replace('"', '');
      const data_pdf_prefix = 'data:application/pdf;base64,'
      const pdfBlob = b64toBlob(data_pdf_prefix + documentResponse[1])

      await this.$nextTick()

      setPdfUrl(pdfBlob, filename)
    } catch (error) {
      console.log(error)
    }
  }
}
</script>